module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-44.a2d0351c.png";